import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, OnInit, output, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AddResumeSkill } from 'src/app/models/resume/add-resume';
import { DropDownKeywords, DropdownOption } from 'src/app/models/shared/dropdown-option';
import { DropdownService } from 'src/app/services/dropdown.service';
import { ResumeService } from 'src/app/services/resume.service';
import Swal from 'sweetalert2';
import { DropdownComponent } from "../../../../shared/dropdown/dropdown.component";

@Component({
  selector: 'app-modal-skill',
  imports: [CommonModule, ReactiveFormsModule, DropdownComponent],
  templateUrl: './modal-skill.component.html',
  styleUrl: './modal-skill.component.css'
})
export class ModalSkillComponent implements OnInit {
  public softSkill = signal<boolean>(false);
  public resumeId = input<number | null>(null);
  public onResumeSkill = output<AddResumeSkill>();

  private readonly resumeService = inject(ResumeService);
  private readonly dropdownService = inject(DropdownService);

  public form = new FormGroup({
    id: new FormControl(0),
    resumeId: new FormControl(0),
    skillId: new FormControl<number  | null>(null, [Validators.required]),
    skillName: new FormControl<any>('', [Validators.maxLength(1000)]),
    skillLevelId: new FormControl(null, [Validators.required]),
    isEnabled: new FormControl(true)
  });

  skills: DropdownOption[] = [];
  skillLevels: DropdownOption[] = [];
  isSearching = signal<boolean>(false);
  showDropdown = signal<boolean>(false);

  isLoading = signal<boolean>(false);

  dropDownKeyword = computed(() => {
    return this.softSkill() ? DropDownKeywords.SoftSkills : DropDownKeywords.TechnicalSkills;
  });

  ngOnInit(): void {
    this.getOptions();
  }

  getOptions() {
    this.dropdownService.GetOptions(this.dropDownKeyword(),null,undefined,true).subscribe({
      next: res => {
        this.skills = res;
      }
    });
    this.dropdownService.GetOptions(DropDownKeywords.SkillLevels,null,undefined,true).subscribe({
      next: res => {
        this.skillLevels = res;
      }
    });
  }

  selectSkill(skill: DropdownOption): void {
    this.form.patchValue({
      skillId: skill.id,
      skillName: skill.text
    }, {
      onlySelf: true,
      emitEvent: false
    })
    this.skills = []
  }

  onFocus(): void {
    if (this.form.get("skillName")?.value && this.skills.length > 0) {
      this.showDropdown.set(true);
    }
  }

  onBlur(): void {
    setTimeout(() => {
      this.showDropdown.set(false);
    }, 200)
  }

  reset() {
    this.form.reset();
    this.form.patchValue({
      isEnabled: true
    }, {
      onlySelf: true,
      emitEvent: false
    });
  }

  closeModal() {
    this.reset();
    let divModal = document.getElementById(`modalHabilidades`);
    let modal = (window as any).bootstrap.Modal.getInstance(divModal);
    modal.hide();
  }

  submit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
   
    const resumeSkill = {
      ...this.form.getRawValue(),
      skillName: this.skills?.find(skill => skill.id == this.form.getRawValue().skillId)?.text,
      skillLevel: this.skillLevels?.find(level => level.id == this.form.getRawValue().skillLevelId)?.text,
      resumeId: this.resumeId(),
      softSkill: this.softSkill()
    } as any as AddResumeSkill;

    if (this.resumeId()) {
      this.isLoading.set(true);
      this.resumeService.addResumeSkill({
        ...resumeSkill
      }).subscribe({
        next: res => {
          this.isLoading.set(false);
          this.onResumeSkill.emit(resumeSkill)
          this.closeModal();
        }, error: res => {
          this.isLoading.set(false);
          Swal.fire({
            title: 'Error',
            text: 'Ocurrió un error al guardar el registro.',
            icon: 'error',
            confirmButtonColor: '#d33'
          });
        }
      })
    } else {
      this.onResumeSkill.emit(resumeSkill);
      this.closeModal();
    }
  }
}